import { BoundingBox } from '@rio-cloud/rio-uikit/mapTypes';
import React from 'react';
import RioMap from 'src/components/Map';
import { ICoordinates, IRoutePoint, ISandboxMarker } from 'src/components/Map/interfaces';
import { IRouteSegment } from 'src/components/Map/interfaces/IRouteSegment';
import { MapDrawingProvider } from 'src/providers/MapDrawingContext';

type Status = 'UP' | 'DOWN' | 'ECQUAL';

export interface Up {
  duration?: Status;
  distance?: Status;
  estimated_consumption?: Status;
  totalCost?: Status;
}

interface CardMapProps {
  duration: string;
  distance: string;
  segments: IRoutePoint[] | IRouteSegment[];
  markers: ISandboxMarker[];
  zoom?: number;
  position?: ICoordinates;
  onSelect?: () => void;
  boundingBox?: BoundingBox;
  height?: string;
  totalCost?: string;
  estimated_consumption?: string;
  isDisabled?: boolean;
  isPrimary?: boolean;
  isUp?: Up;
}

interface Row {
  type: string;
  value?: string;
  isUp?: Status;
  isPrimary: boolean;
}
const RowC = ({
  type,
  value,
  isUp,
  isPrimary,
}: Row) => {
  let icon = null;

  if (!isPrimary) {
    switch (isUp) {
      case 'UP':
        icon = <div className="width-10 height-10 bg-success rounded" />;
        break;
      case 'DOWN':
        icon = <div className="width-10 height-10 bg-danger rounded" />;
        break;
      case 'ECQUAL':
        icon = <div />;
        break;
      default:
        icon = <div className="width-10 height-10 bg-success rounded" />;
        // icon = ''
        break;
    }
  }

  return (
    <div className="display-flex align-items-center text-size-16 text-color-secondary margin-0">
      <span>{type}:</span>
      <span className="text-bold text-color-black margin-left-5">{value}</span>
      {isPrimary ? null : icon && <span className="margin-left-5">{icon}</span>}
    </div>
  );
};


const CardMap: React.FC<CardMapProps> = ({
  duration,
  distance,
  segments,
  markers,
  zoom,
  position,
  onSelect,
  boundingBox,
  height = 'height-300',
  totalCost,
  estimated_consumption,
  isDisabled = false,
  isPrimary = false,
  isUp,
}) => {
  
  return (
    <div className="bg-white rounded shadow-default overflow-hidden width-100pct">
      <div className={`width-100pct ${height} padding-20 padding-bottom-0`}>
        <MapDrawingProvider>
          <RioMap
            showInterestPoints={false}
            showAreas
            apiKey={process.env.REACT_APP_RIO_MAP_KEY as string}
            segments={Array.isArray(segments) && (segments as any)[0]?.points ? segments as IRouteSegment[] : segments.length ? [{ points: segments as IRoutePoint[], alternative: false }] : []}
            markers={markers}
            boundingBox={boundingBox}
            useClusters={true}
            zoom={zoom}
            position={position}
          />
        </MapDrawingProvider>
      </div>
      <div className="padding-20">
        <div className="margin-bottom-20">
          <RowC
            isUp={isUp?.duration}
            type='Duração'
            value={duration}
            isPrimary={isPrimary}
          />
          <RowC
            isUp={isUp?.distance}
            type='Distância'
            value={distance}
            isPrimary={isPrimary}
          />
          <RowC
            isUp={isUp?.estimated_consumption}
            type='Consumo estimado'
            isPrimary={isPrimary}
            value={estimated_consumption}
          />
          <RowC
            isUp={isUp?.totalCost}
            type='Custo total'
            isPrimary={isPrimary}
            value={totalCost}
          />
        </div>
        {onSelect ? (
          <button
            className={`btn btn-primary width-100pct ${isDisabled ? 'btn-loading btn-icon-only disabled' : ''}`}
            onClick={!isDisabled ? onSelect : undefined}
            disabled={isDisabled}
          >
            {!isDisabled && 'Selecionar'}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default CardMap; 